import { render, staticRenderFns } from "./newDrawer.vue?vue&type=template&id=4b16a573"
import script from "./newDrawer.vue?vue&type=script&lang=js"
export * from "./newDrawer.vue?vue&type=script&lang=js"
import style0 from "./newDrawer.vue?vue&type=style&index=0&id=4b16a573&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports